import { getDataWrapperSchema } from '@repo/schema/data-wrapper'
import { UpFetch } from '@repo/upfetch'

import { createProcedure } from '../../lib/procedure'
import { GetCustomsDocumentSchema, GetCustomsSchema } from '@repo/schema/customs'
import { z } from '@repo/schema'

export const createCustomsRoute = (upFetch: UpFetch) => {
  const p = createProcedure(upFetch)

  return {
    documents: {
      // DELETE /loads/:loadId/documents/:documentId
      delete: p
        .path(z.object({ documentId: z.number(), loadId: z.number() }), p => [
          'loads',
          p.loadId,
          'documents',
          p.documentId,
        ])
        .mutation(({ path, upFetch }) => upFetch(path, { method: 'DELETE' })),

      // GET /loads/:loadId/documents/:documentId/download
      downloadUrl: p
        .path(z.object({ documentId: z.number(), loadId: z.number() }), p => [
          'loads',
          p.loadId,
          'documents',
          p.documentId,
          'download',
        ])
        .query(({ path, upFetch }) => upFetch<{ url: string }>(path)),

      // GET /loads/:loadId/documents/custom
      list: p
        .path(z.object({ loadId: z.number() }), p => ['loads', p.loadId, 'documents', 'custom'])
        .query(({ path, upFetch }) =>
          upFetch(path, {
            schema: getDataWrapperSchema(z.array(GetCustomsDocumentSchema)),
          }),
        ),

      // GET /loads/:loadId/documents/:documentId/preview
      previewUrl: p
        .path(z.object({ documentId: z.number(), loadId: z.number() }), p => [
          'loads',
          p.loadId,
          'documents',
          p.documentId,
          'preview',
        ])
        .query(({ path, upFetch }) => upFetch<{ url: string }>(path)),

      // POST /loads/:loadId/documents  (type fixed = custom, matches the /documents/custom list)
      upload: p
        .path(z.object({ loadId: z.number() }), p => ['loads', p.loadId, 'documents'])
        .input(z.object({ files: z.array(z.instanceof(File)) }))
        .mutation(({ input, path, upFetch }) => {
          const formData = new FormData()
          formData.append('type', 'custom')
          for (const file of input.files) {
            formData.append('files[]', file)
          }
          return upFetch(path, {
            body: formData,
            method: 'POST',
            schema: getDataWrapperSchema(z.array(GetCustomsDocumentSchema)),
          })
        }),
    },
    get: p
      .path(z.object({ loadId: z.number() }), p => ['loads', p.loadId, 'customs'])
      .query(({ path, upFetch }) =>
        upFetch(path, {
          schema: getDataWrapperSchema(GetCustomsSchema),
        }),
      ),
    update: p
      .path(z.object({ loadId: z.number() }), p => ['loads', p.loadId, 'customs'])
      .input(
        z
          .object({
            notes: z.string().nullish(),
            required: z.boolean(),
            responsible_party: z.enum(['organisation', 'customer']).nullish(),
          })
          .partial(),
      )
      .mutation(({ input, path, upFetch }) =>
        upFetch(path, {
          body: input,
          method: 'PATCH',
        }),
      ),
  }
}
